import { render, staticRenderFns } from "./SamlCallbackPage.vue?vue&type=template&id=277fa0a6&scoped=true"
import script from "./SamlCallbackPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SamlCallbackPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SamlCallbackPage.vue?vue&type=style&index=0&id=277fa0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277fa0a6",
  null
  
)

export default component.exports